import { render, staticRenderFns } from "./ActivityBlock.vue?vue&type=template&id=400832b8&scoped=true&"
import script from "./ActivityBlock.vue?vue&type=script&lang=js&"
export * from "./ActivityBlock.vue?vue&type=script&lang=js&"
import style0 from "./ActivityBlock.vue?vue&type=style&index=0&id=400832b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400832b8",
  null
  
)

export default component.exports